module.exports = __webpack_public_path__ + "img/horizontal_7_5_8003.741b80ef.png";